import React, { useContext } from "react";
import "../styles/footer.css";
import EmailIcon from "@mui/icons-material/Email";
import PhoneIphoneIcon from "@mui/icons-material/PhoneIphone";
import Box from "@mui/material/Box";
import { footerValues } from "../utils/constants";
import { ClientContext } from "../../store/context";
import { convertToLanguage, findObgjectInArray } from "../utils/generalUtils";
import { usePost } from "../hooks/Hooks";
import { siteValuesApi } from "../api/GardenoApi";
function Footer() {
  const { language } = useContext(ClientContext);
  const [settings, settigsError] = usePost(
    siteValuesApi.getAllValues,
    convertToLanguage(language),
    footerValues
  );
  return (
    <div className="footer-grid-column-container ">
      <Box
        className="footer-grid-column"
        sx={{ width: { xs: "95%", lg: "60%" } }}
      >
        <div className="footer-email-phone">
          <div style={{ display: "flex", alignItems: "center" }}>
            <EmailIcon sx={{ color: "#FFF" }} />
            <span style={{ color: "#FFF" }}>
              {settings != null
                ? findObgjectInArray(settings, "name", "SITE_EMAIL")["value"]
                : ""}
            </span>
          </div>
          <div style={{ display: "flex", alignItems: "center" }}>
            <PhoneIphoneIcon sx={{ color: "#FFF" }} />
            <span style={{ color: "#FFF" }}>
              {settings != null
                ? findObgjectInArray(settings, "name", "SITE_NUMBER")["value"]
                : ""}
            </span>
          </div>
        </div>
        <Box
          className="footer-icon-container"
          sx={{ justifyContent: { xs: "flex-start", lg: "flex-end" } }}
        >
          <a
            href={
              settings != null
                ? findObgjectInArray(settings, "name", "SITE_INSTAGRAM_LINK")[
                    "value"
                  ]
                : ""
            }
            target="_blank"
            style={{ display: "flex" }}
          >
            <img
              className="footer-icon"
              src={require("../assets/fb_white.png")}
            />
          </a>
          <a
            href={
              settings != null
                ? findObgjectInArray(settings, "name", "SITE_FACEBOOK_LINK")[
                    "value"
                  ]
                : ""
            }
            target="_blank"
            style={{ display: "flex" }}
          >
            <img
              className="footer-icon"
              src={require("../assets/insta_white.png")}
            />
          </a>
        </Box>
      </Box>
    </div>
  );
}

export default Footer;
